<template>
  <div id="map" style="text-align: left;"><span class="H_copyright" style="background-color: rgb(254 186 53); padding: 2px 16px;">Current shipment position </span>
    <!--In the following div the HERE Map will render-->
    <div
      v-if="hasCoordinates()"
      id="mapContainer"
      ref="hereMap" />
    <iframe
      v-if="hasUrl()"
      id="urlMapContainer"
      ref="urlMap"
      src="" />
  </div>
</template>

<script>

export default {
  name: 'ParcelMap',
  props: {
    center: {
      type: Object,
      default: function () { return {} }
    },
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      platform: null,
      apikey: process.env.VUE_APP_HERE_MAP_KEY
    }
  },
  async mounted () {
    // Initialize the platform object:
    const platform = new window.H.service.Platform({
      apikey: this.apikey
    })
    this.platform = platform
    if (this.hasCoordinates()) {
      this.initializeHereMap()
    } else if (this.hasUrl()) {
      this.initializeUrlMap()
    }
  },
  methods: {
    initializeHereMap () { // rendering map
      const mapContainer = this.$refs.hereMap
      // Initialize the platform object:
      const H = window.H
      // Obtain the default map types from the platform object
      var maptypes = this.platform.createDefaultLayers()

      // Instantiate (and display) a map object:
      var map = new H.Map(mapContainer, maptypes.vector.normal.map, {
        zoom: 10,
        center: this.center
      })

      addEventListener('resize', () => map.getViewPort().resize())

      // add behavior control
      var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map))

      // add UI
      H.ui.UI.createDefault(map, maptypes)

      // add marker
      var marker = new H.map.Marker(this.center)
      map.addObject(marker)
      // End rendering the initial map
    },
    initializeUrlMap () {
      this.$refs.urlMap.src = this.url
    },
    hasCoordinates () {
      return this.center !== null && !isNaN(this.center.lat) && this.center.lat !== 0.0
    },
    hasUrl () {
      return this.url !== null && this.url !== ''
    }
  }
}
</script>

<style scoped>
#map {
  width: 100%;
  text-align: center;
  background-color: #fdfdfd;
}
#mapContainer, #urlMapContainer {
    height: 334px;
    width: 100%;
}
</style>
